<template>
    <div class="main">
        <h3>{{ $t('reservationPayment.method')}}</h3>
        <p class="hint">{{ $t('reservationPayment.promise')}}</p>
        <div class="box-shadow">
            <el-collapse v-model="activeName" accordion @change="handleChange">
                <el-radio-group v-model="activeName">
                    <el-collapse-item name="3" class="icon-CreditCard">
                        <template slot="title">
                            <el-radio :label="'3'" v-if="false"></el-radio>
                            <span class="payment_name">{{ $t('reservationPayment.creditCard')}}</span>
                        </template>
                        <div class="collapse-content">
                            <div class="cell example example3" id="example-3">
                                <form ref="test" id="payment-form" @submit.prevent="validation">
                                    <div class="alert alert-danger" role="alert" v-if="paymentError">
                                        <div v-for="(err,index) in paymentError" :key="index">{{ err }}</div>
                                    </div>
                                    <div class="fieldset">
                                        <div class="field_box1">
                                            <div id="example3-card-number" class="field empty"></div>
                                            <p
                                                class="field_name"
                                            >{{ $t('reservationPayment.creditCard1')}}</p>
                                        </div>
                                        <div class="field_box field_bg">
                                            <input
                                                id="example3-name"
                                                data-tid="elements_examples.form.postal_code_placeholder"
                                                class="field empty third-width"
                                                placeholder
                                            >
                                            <p
                                                class="field_name"
                                            >{{ $t('reservationPayment.creditCard2')}}</p>
                                        </div>
                                        <div class="field_box">
                                            <div
                                                id="example3-card-expiry"
                                                class="field empty third-width"
                                            ></div>
                                            <p
                                                class="field_name"
                                            >{{ $t('reservationPayment.creditCard3')}}</p>
                                        </div>
                                        <div class="field_box">
                                            <div
                                                id="example3-card-cvc"
                                                class="field empty third-width"
                                            ></div>
                                            <p
                                                class="field_name"
                                            >{{ $t('reservationPayment.creditCard4')}}</p>
                                            <div class="touch_here">
                                                <p
                                                    class="hover_hint"
                                                >{{ $t('reservationPayment.creditCard_msg1')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="error" role="alert">
                                        <span
                                            class="message"
                                        >{{ $t('reservationPayment.creditCard_msg2')}}</span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item
                        name="5"
                        v-if="false"
                        :class="{ 'disabled': isNotCNY }"
                        class="icon-WechatPay"
                    >
                        <template slot="title">
                            <el-radio :label="'5'"></el-radio>
                            <span class="payment_name">{{ $t('reservationPayment.wechat')}}</span>
                            <span
                                class="payment_hint"
                                v-if="isNotCNY"
                            >{{ $t('reservationPayment.available')}}</span>
                        </template>
                        <div class="collapse-content">
                            <div class="mobile_payment wechat_pay clearfix">
                                <div class="fl">
                                    <img
                                        src="../../../website_20/static/img/web-wechat-pay-qrcode@3x.png"
                                        alt="Pay QR Code"
                                    >
                                </div>
                                <div class="fl QRcode_info">
                                    <h5>{{ $t('reservationPayment.scanQR')}}</h5>
                                    <p>{{ $t('reservationPayment.scanWechat')}}</p>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item
                        name="6"
                        v-if="false"
                        :class="{ 'disabled': isNotCNY }"
                        class="icon-AliPay"
                    >
                        <template slot="title">
                            <el-radio :label="'6'"></el-radio>
                            <span class="payment_name">{{ $t('reservationPayment.alipay')}}</span>
                            <span
                                class="payment_hint"
                                v-if="isNotCNY"
                            >{{ $t('reservationPayment.available')}}</span>
                        </template>
                        <div class="collapse-content">
                            <div class="mobile_payment wechat_pay clearfix">
                                <div class="fl">
                                    <img
                                        src="../../../website_20/static/img/web-wechat-pay-qrcode@3x.png"
                                        alt="Pay QR Code"
                                    >
                                </div>
                                <div class="fl QRcode_info">
                                    <h5>{{ $t('reservationPayment.scanQR')}}</h5>
                                    <p>{{ $t('reservationPayment.scanAlipay')}}</p>
                                </div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-radio-group>
            </el-collapse>
        </div>
        <div class="clearfix safe_promise">
            <div class="fl">
                <h5>{{ $t('reservationPayment.promise1')}}</h5>
                <p>{{ $t('reservationPayment.promise2')}}</p>
            </div>
            <div class="fr">
                <h5>{{ $t('reservationPayment.promise_title1')}}</h5>
                <p>
                    {{ $t('reservationPayment.promise_title2')}}
                    <span>{{ $t('reservationPayment.promise_title2_hint')}}</span>
                    {{ $t('reservationPayment.promise_title2_1')}}
                </p>
            </div>
        </div>
    </div>
</template>


<script>
import registerElements from "../assets/js/stripe.common";

function initStripe() {
    if (!window.Stripe) {
        return;
    }

    let stripe = Stripe(
        document.getElementById("app").attributes.publishablekey.value
    );

    // Create an instance of Elements.
    let elements = stripe.elements({
        fonts: [
            {
                cssSrc: "https://fonts.googleapis.com/css?family=Quicksand"
            }
        ],
        // Stripe's examples are localized to specific languages, but if
        // you wish to have Elements automatically detect your user's locale,
        // use `locale: 'auto'` instead.
        locale: "auto"
    });
    const elementStyles = {
        base: {
            color: "#333",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            "border-color": "#3b6bbf",
            "background-color": "#fff",

            ":focus": {
                color: "#333333",
                "background-color": "#fff"
            },

            "::placeholder": {
                color: "#9b9b9b",
                "background-color": "#fff"
            },

            ":focus::placeholder": {
                color: "#9b9b9b",
                "background-color": "#fff"
            }
        },
        invalid: {
            color: "#bc3036",
            "border-color": "#bc3036",

            ":focus": {
                color: "#bc3036"
            },
            "::placeholder": {
                color: "#bc3036"
            }
        }
    };
    let elementClasses = {
        focus: "focus",
        empty: "empty",
        invalid: "invalid"
    };

    let cardNumber = elements.create("cardNumber", {
            style: elementStyles,
            classes: elementClasses
        }),
        cardExpiry = elements.create("cardExpiry", {
            style: elementStyles,
            classes: elementClasses
        }),
        cardCvc = elements.create("cardCvc", {
            style: elementStyles,
            classes: elementClasses
        });

    let loading;

    return {
        name: "ReservationPayment",

        props: {
            paymentField: {},
            cardError: {}
        },

        data() {
            return {
                paymentError: null,
                activeName: "3",
                can_pay: false,
                paymentSuccess: undefined,
                radio: "3",
                td_id: "",
                isNotCNY: true,
                disabled: false,
                data_paymentField: this.paymentField,
                project_val: this.$root.project,
                publishabel_val: this.$root.publishableKey
            };
        },

        mounted: function() {
            this.$emit("payment", {
                payment_way: this.activeName,
                paymentSuccess: this.paymentSuccess
            });

            cardNumber.mount("#example3-card-number");
            cardExpiry.mount("#example3-card-expiry");
            cardCvc.mount("#example3-card-cvc");
            this.td_id = registerElements(
                [cardNumber, cardExpiry, cardCvc],
                "example3",
                stripe,
                this
            );

            loading = this.$loading({
                lock: true,
                target: ".box-shadow",
                text: "Loading...",
                spinner: "el-icon-loading",
                color: "#3b6bbf",
                background: "rgba(255, 255, 255, 0.8)"
            });

            cardNumber.on("ready", function() {
                loading.close();
            });
        },

        beforeMount() {
            let currentCurrency = undefined,
                name = "Cur",
                ca = document.cookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(name) === 0) {
                    // name.length + 1: reduce = symbol,   c.length - 2: reduce currency symbol and space
                    currentCurrency = c.substring(name.length + 1, c.length);
                }
            }

            if (currentCurrency == "CNY") {
                this.isNotCNY = false;
            } else {
                this.isNotCNY = true;
            }
        },

        methods: {
            enterForm(e) {
                let tokenValid = resp => {
                    // Card is not valid
                    if (!resp.token || !resp.token.id) {
                        return;
                    }

                    // Loading data
                    loading = this.$loading({
                        lock: true,
                        target: ".payment-main",
                        text: "Processing payment ... ",
                        spinner: "el-icon-loading",
                        color: "#3b6bbf",
                        background: "rgba(255, 255, 255, 0.8)"
                    });

                    this.$http
                        .patch(
                            `${this.$root.apiReservation}${
                                this.paymentField.payment_id
                            }/`,
                            {
                                stripe_source: resp.token.id
                            }
                        )
                        .then(resp => {
                            if (resp.data.captured) {
                                this.paySuccess = true;
                                this.$emit("payment", {
                                    payment_way: this.activeName,
                                    paymentSuccess: this.paySuccess
                                });
                            } else {
                                this.paySuccess = false;
                                this.$emit("payment", {
                                    payment_way: this.activeName,
                                    paymentSuccess: this.paySuccess
                                });
                            }
                        })
                        .catch(response => {
                            this.$parent.$parent.$parent.disabledPaymentSubmit = false;
                            if (response.body && response.body.stripe_source) {
                                this.paymentError = response.body.stripe_source;
                            } else {
                                this.paymentError = ["Unknown error"];
                            }
                        })
                        .finally(response => {
                            loading.close();
                        });
                };

                let elem = document.querySelector("form");
                let submitEvt = new CustomEvent("submit", {
                    detail: { toRegister: true },
                    cancelable: true
                });
                elem.dispatchEvent(submitEvt);

                submitEvt.tokenPromise.then(tokenValid);
            },

            handleChange(e) {
                this.$emit("payment", {
                    payment_way: this.activeName,
                    paymentSuccess: this.paymentSuccess
                });
                // wechat pay
                if (this.activeName == "5") {
                    this.clearForm();
                    // alipay
                } else if (this.active == "6") {
                    this.clearForm();
                }
            },

            getCookie(name) {
                let ca = document.cookie.split(";");
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i].trim();
                    if (c.indexOf(name) === 0) {
                        // name.length + 1: reduce = symbol,   c.length - 2: reduce currency symbol and space
                        return c.substring(name.length + 1, c.length);
                    }
                }
            },

            validation(evt) {
                if (evt.detail && evt.detail.toRegister) {
                    registerElements(
                        [cardNumber, cardExpiry, cardCvc],
                        "example3",
                        stripe,
                        this
                    );
                } else {
                    this.$parent.$parent.$parent.reserve();
                }
            },

            clearForm() {
                let formClass = "." + "example3";
                let example = document.querySelector(formClass);
                let form = example.querySelector("form");

                form.reset();

                // Clear each Element.
                [cardNumber, cardExpiry, cardCvc].forEach(function(element) {
                    element.clear();
                });

                let error = form.querySelector(".error");
                error.classList.remove("visible");

                // Resetting the form does not un-disable inputs, so we need to do it separately:
                // this.enableInputs(form);
                example.classList.remove("submitted");
            }
        },

        watch: {
            "paymentField.clicked": {
                handler(newVal, oldVal) {
                    this.enterForm();
                },
                deep: true
            },

            "paymentField.payment_id": {
                handler(newVal, oldVal) {
                    this.paymentField.payment_id = newVal;
                }
            },

            paymentSuccess: {
                handler(newVal, oldVal) {
                    // console.log(newVal, oldVal);
                    // this.$emit
                }
            }
        }
    };
}

export default initStripe();
</script>
<style scoped>
@import "../assets/css/payment-common.css";

.disabled {
    pointer-events: none;
}

.error,
.success {
    display: none;
}

.box-shadow >>> .el-loading-spinner i,
.box-shadow >>> .el-loading-spinner .el-loading-text {
    color: rgba(59, 107, 191, 1);
}

.box-shadow >>> .el-collapse-item__wrap {
    overflow: visible;
    border-bottom: none;
}

.box-shadow >>> .el-radio-group {
    /* margin: 20px 0 20px -5px; */
    /* margin: 20px 0 20px 0; */
}

.box-shadow >>> .el-radio-group .el-collapse-item:last-child {
    border-radius: 0 0 6px 6px;
    /* overflow: hidden; */
    padding: 20px 0 30px 0;
}
.box-shadow >>> .el-collapse-item {
    position: relative;
}

.box-shadow >>> .el-collapse-item:after {
    content: "";
    position: absolute;
    display: block;
    right: 38px;
    top: 0;
    background: url("../../../website_20/static/img/group-2.svg") no-repeat;
}

.el-collapse-item.icon-CreditCard:after {
    right: 20px;
    top: 46px;
    width: 114px;
    height: 24px;
}

.el-collapse-item.icon-WechatPay:after {
    right: 38px;
    top: 25px;
    width: 106px;
    height: 28px;
    background-position: -251px 0;
}

.el-collapse-item.icon-AliPay:after {
    right: 38px;
    top: 25px;
    width: 106px;
    height: 28px;
    background-position: -128px 0;
}

/* .is-active.el-collapse-item.icon-CreditCard:after {
    top: 6px;
} */
/* .is-active.el-collapse-item.icon-WechatPay:after {
    top: 25px;
} */
/* .is-active.el-collapse-item.icon-AliPay:after {
    top: 25px;
} */

.box-shadow >>> .el-collapse-item .el-collapse-item__header {
    position: relative;
    font-size: 16px;
    font-family: GothamBold;
    padding-left: 78px;
    font-weight: bold;
    color: #0d253f;
    border-radius: 6px 6px 0 0;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header span.payment_name {
    /* display: block;
    width: 100%;
    margin-top: 12px; */
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header span.payment_hint {
    /* line-height: 1.5;
    margin-left: 0;
    max-width: 190px;
    margin-bottom: 23px; */
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header span.payment_hint {
    font-weight: normal;
    margin-left: 10px;
    font-family: GothamBook;
    font-size: 12px;
    color: rgb(155, 155, 155);
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header.is-active {
    /* font-size: 16px; */
}

.box-shadow >>> .el-collapse-item .el-radio {
    top: 28px;
    left: 40px;
}

.box-shadow .el-collapse-item .collapse-content .mobile_payment {
    padding: 7px 0 28px;
}

.box-shadow .el-collapse-item .collapse-content .mobile_payment .fl img {
    width: 100px;
    height: 100px;
}

.box-shadow .el-collapse-item .collapse-content .mobile_payment .QRcode_info {
    margin-left: 17px;
    margin-top: 6px;
}

.box-shadow
    .el-collapse-item
    .collapse-content
    .mobile_payment
    .QRcode_info
    h5 {
    height: 14.6px;
    font-size: 13.6px;
    font-weight: 500;
    color: #3b6bbf;
    margin-bottom: 5.4px;
}

.box-shadow .el-collapse-item .collapse-content .mobile_payment .QRcode_info p {
    width: 187.5px;
    font-family: OpenSans;
    font-size: 12px;
    line-height: 1.42;
    color: #666;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header .el-icon-arrow-right {
    display: none;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header .el-icon-arrow-right {
    display: none;
    /* transform: rotate(-90deg); */
}

.box-shadow >>> .el-collapse-item .el-collapse-item__header .el-collapse-item__arrow.is-active {
    display: none;
    /* transform: rotate(90deg) */
}

.safe_promise {
    padding: 25px 0 41px;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
}

.safe_promise h5 {
    height: 24px;
    line-height: 24px;
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
    color: #666;
    margin-bottom: 4px;
}

.safe_promise p {
    font-family: GothamBook;
    font-size: 12px;
    line-height: 1.6;
    color: #666;
}

.safe_promise p span {
    font-family: GothamBold;
}

.safe_promise > .fl, .safe_promise > .fr {
    display: inline-block;
    width: 100%;
    padding-left: 65px;
    position: relative;
}

.safe_promise .fl:before, .safe_promise .fr:after {
    content: "";
    position: absolute;
    width: 45px;
    height: 45px;
    left: 0;
    top: 6px;
    background: url("../../../website_20/static/img/stacked-group-payment.svg") no-repeat;
    background-position: -368px 0;
}

.safe_promise .fr:after {
    background-position: -428px 0;
}

.box-shadow >>> .el-collapse-item .el-collapse-item__content {
    padding: 0 60px;
}

@media (max-width: 992px) {
    .safe_promise {
        flex-wrap: wrap;
    }
    .safe_promise > .fl {
        margin-bottom: 30px;
    }

    .box-shadow >>> .el-collapse-item .el-collapse-item__header {
        color: #1b2125;
        padding-left: 58px;
        min-height: 76px;
        height: auto;
        flex-wrap: wrap;
    }

    .box-shadow >>> .el-radio-group {
        margin-left: 0;
    }

    .box-shadow >>> .el-collapse-item .el-radio {
        left: 20px;
    }
    .box-shadow >>> .el-collapse-item .el-collapse-item__content {
        padding: 0 20px;
    }
    .example.example3 .fieldset .field_box {
        width: 100%;
    }
    .example.example3 .fieldset .field_box:nth-child(3),
    .example.example3 .fieldset .field_box:nth-child(4) {
        width: 50%;
    }
    .example.example3 .fieldset .field_box:nth-child(3) {
        padding-right: 10.2px;
    }
    .example.example3 .fieldset .field_box:nth-child(4) {
        margin-left: 0;
    }

    .box-shadow >>> .el-collapse-item.disabled .el-collapse-item__header span.payment_name {
        display: block;
        width: 100%;
        margin-top: 12px;
    }

    .box-shadow >>> .el-collapse-item .el-collapse-item__header span.payment_hint {
        line-height: 1.5;
        margin-left: 0;
        max-width: 190px;
        margin-bottom: 23px;
    }

    .safe_promise .fl {
        margin-bottom: 30px;
    }
}

@media (max-width: 414px) {
    .box-shadow .el-collapse-item .collapse-content .mobile_payment .QRcode_info {
        margin-left: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ReservationPayment.vue